module.exports = __webpack_public_path__ + "static/media/call.e0fc04df.svg";